import { GeoPoint, Timestamp } from 'firebase/firestore'
import { z } from 'zod'

export const TeamLocationZod = z
  .object({
    geolocation: z
      .instanceof(GeoPoint)
      .transform((v) => ({ lat: v.latitude, lng: v.longitude }))
      .readonly(),
    timestamp: z.instanceof(Timestamp).transform((v) => v.toDate()),
    transportRequestId: z.string().optional(),
  })
  .readonly()
